module.exports = __webpack_public_path__ + "static/media/qrcode.9fc87ee6.png";